import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import LoginPage from "../pages/LoginPage.vue";
import SendMessagePage from "@/pages/SendMessagePage.vue";
import UploadImage from "@/pages/UploadImage.vue";
import RegisterPage from "@/pages/RegisterPage.vue";
import UserList from "@/pages/UserList.vue";
import UserUpdatePage from "@/pages/UserUpdatePage.vue";
// Tạm thời ẩn chức năng Thuế.
// import AddTax from "@/pages/AddTax.vue";
import addGroupAndMemberPage from "@/pages/AddGroupAndMemberPage.vue";
import residentList from "@/pages/ResidentList.vue";
import residentUpdatePage from "@/pages/ResidentUpdatePage.vue";
import addManagerFeedbackPage from "@/pages/AddManagerFeedbackPage.vue";
import FullCalendar from "@/pages/FullCalendar.vue";
import AddPeople from "@/pages/AddPeople.vue";
import uploadDocument from "@/pages/UploadDocument.vue";
import viewDocument from "@/pages/ViewDocument.vue";
import documentProcessList from "@/pages/DocumentProcessList.vue";
import documentStatusList from "@/pages/DocumentStatusList.vue";
import NotFoundPage from "@/pages/NotFoundPage.vue";
import ListFeedbackPage from "@/pages/ListFeedbackPage.vue";
import FeedbackDashboardPage from "@/pages/FeedbackDashboardPage.vue";
import ListEmergencyPage from "@/pages/ListEmergencyPage.vue";
import HelpGuidePage from "@/pages/HelpGuidePage.vue";
import FAQPage from "@/pages/FAQPage.vue";
import store from "@/store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/sendmessage",
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    props: true,
  },
  {
    path: "/register",
    name: "register",
    component: RegisterPage,
    props: true,
  },
  {
    path: "/residentList",
    name: "residentList",
    component: residentList,
    props: true,
  },
  {
    path: "/home",
    name: "home",
    redirect: "/sendmessage",
  },
  {
    path: "/sendmessage",
    name: "sendmessage",
    component: SendMessagePage,
    props: true,
  },
  {
    path: "/uploadImage",
    name: "uploadImage",
    component: UploadImage,
    props: true,
  },
  {
    path: "/managerGroup",
    name: "managerGroup",
    component: addGroupAndMemberPage,
    props: true,
  },
  {
    path: "/userList",
    name: "userList",
    component: UserList,
    props: true,
  },
  {
    path: "/viewDocument/:id",
    name: "viewDocument",
    component: viewDocument,
    props: true,
  },
  // {
  //   path: '/addTax',
  //   name: 'addTax',
  //   component: AddTax,
  //   props: true
  // },
  {
    path: "/addPeople",
    name: "addPeople",
    component: AddPeople,
    props: true,
  },
  {
    path: "/addManagerFeedbackPage",
    name: "addManagerFeedbackPage",
    component: addManagerFeedbackPage,
    props: true,
  },
  {
    path: "/feedbackList",
    name: "feedbackList",
    component: ListFeedbackPage,
    props: true,
  },
  {
    path: "/feedbackDashboard",
    name: "feedbackDashboard",
    component: FeedbackDashboardPage,
    props: true,
  },
  {
    path: "/emergencyList",
    name: "emergencyList",
    component: ListEmergencyPage,
    props: true,
  },
  // {
  //   path: '/addManagerCheckinPage',
  //   name: 'addManagerCheckinPage',
  //   component: addManagerCheckinPage,
  //   props: true
  // },
  {
    path: "/fullCalendar",
    name: "fullCalendar",
    component: FullCalendar,
    props: true,
  },
  {
    path: "/uploadDocument",
    name: "uploadDocument",
    component: uploadDocument,
    props: true,
  },
  {
    path: "/documentProcessList",
    name: "documentProcessList",
    component: documentProcessList,
    props: true,
  },
  {
    path: "/documentStatusList",
    name: "documentStatusList",
    component: documentStatusList,
    props: true,
  },
  {
    path: "/guide",
    name: "guide",
    component: HelpGuidePage,
    props: true,
  },
  {
    path: "/faq",
    name: "faq",
    component: FAQPage,
    props: true,
  },
  {
    path: "/userUpdate/:id",
    name: "userUpdate",
    component: UserUpdatePage,
    props: true,
  },
  {
    path: "/residentUpdatePage/:id",
    name: "residentUpdatePage",
    component: residentUpdatePage,
    props: true,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: NotFoundPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  const isLoggedIn = !!store.state.token;

  if (to.name === "login" && isLoggedIn) {
    return { name: "sendmessage" };
  }

  if (to.name !== "login" && !isLoggedIn) {
    return { name: "login" };
  }

  return true;
});

export default router;
